// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-issuance-wrapper {
  width: 80%; }
  .agent-issuance-wrapper .issue-card-wrapper {
    padding: 5px 40px; }
  .agent-issuance-wrapper .no-action-row {
    display: flex;
    justify-content: center;
    padding: 30px; }
    .agent-issuance-wrapper .no-action-row .no-action-message {
      font-size: 25px; }
  .agent-issuance-wrapper .date-container {
    text-align: left; }
    @media screen and (min-width: 768px) {
      .agent-issuance-wrapper .date-container {
        margin-right: 24px; } }
    .agent-issuance-wrapper .date-container span {
      color: white;
      width: 100px;
      font-size: 19px; }
    .agent-issuance-wrapper .date-container .date-picker-field {
      background-color: black;
      border: none;
      border-bottom: 1px solid white;
      min-width: 240px;
      width: 100%;
      color: white;
      min-width: 300px; }
  .agent-issuance-wrapper .switch-tabs {
    display: flex;
    flex-direction: row;
    margin: 30px;
    gap: 10px;
    border-bottom: 1px solid white; }
    .agent-issuance-wrapper .switch-tabs .tabs {
      border: 1px solid white;
      padding: 15px;
      font-size: 18px;
      background-color: black;
      border-bottom: 0;
      border-radius: 5px 5px 0 0;
      margin-bottom: -2px; }
      .agent-issuance-wrapper .switch-tabs .tabs:hover {
        background-color: grey; }
    .agent-issuance-wrapper .switch-tabs .active {
      color: var(--color-yellow);
      -webkit-text-decoration: var(--color-yellow) underline;
              text-decoration: var(--color-yellow) underline;
      text-underline-offset: 5px; }
  .agent-issuance-wrapper .agent-issuance-fields {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    gap: 20px;
    padding: 20px 50px; }
  .agent-issuance-wrapper .agent-issuance-filter {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 10px 50px; }
    .agent-issuance-wrapper .agent-issuance-filter .issuance-btn {
      width: 80%; }
      @media screen and (min-width: 1200px) {
        .agent-issuance-wrapper .agent-issuance-filter .issuance-btn {
          width: 40%; } }
  .agent-issuance-wrapper .action-footer button {
    width: 30%;
    font-size: 16px;
    margin-bottom: 14px; }
    @media (min-width: 720px) {
      .agent-issuance-wrapper .action-footer button {
        width: calc(50% - 7px); }
        .agent-issuance-wrapper .action-footer button:first-child {
          margin-right: 14px; } }

.issued-card-filter-buttons {
  display: flex;
  margin-top: 20px;
  flex-direction: row;
  justify-content: space-between; }
  .issued-card-filter-buttons .filter-buttons {
    display: flex;
    flex-direction: row;
    width: 600px; }
  .issued-card-filter-buttons .export-buttons {
    width: 300px; }
  .issued-card-filter-buttons button {
    margin: 15px 7px;
    width: 100%; }

.add-spacing {
  gap: 10px; }

.MuiTableSortLabel-root {
  color: #ffffff !important; }
  .MuiTableSortLabel-root:hover {
    color: #ffffff !important; }
`, "",{"version":3,"sources":["webpack://./src/pages/agent-issuance/IssueCardTable.scss"],"names":[],"mappings":"AAAA;EACE,UAAU,EAAA;EADZ;IAGI,iBAAiB,EAAA;EAHrB;IAWI,aAAa;IACb,uBAAuB;IACvB,aAAa,EAAA;IAbjB;MAeM,eAAe,EAAA;EAfrB;IAqBI,gBAAgB,EAAA;IAChB;MAtBJ;QAwBM,kBAAkB,EAAA,EAgBrB;IAxCH;MA2BM,YAAY;MACZ,YAAY;MACZ,eAAe,EAAA;IA7BrB;MAgCM,uBAAuB;MACvB,YAAY;MACZ,8BAA8B;MAC9B,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,gBAAgB,EAAA;EAtCtB;IA2CI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,8BAA8B,EAAA;IA/ClC;MAiDM,uBAAuB;MACvB,aAAa;MACb,eAAe;MACf,uBAAuB;MACvB,gBAAgB;MAChB,0BAA0B;MAC1B,mBAAmB,EAAA;MAvDzB;QA0DQ,sBAAsB,EAAA;IA1D9B;MA8DM,0BAA0B;MAC1B,sDAA8C;cAA9C,8CAA8C;MAC9C,0BAA0B,EAAA;EAhEhC;IAqEI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,kBAAkB,EAAA;EAzEtB;IA4EI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB,EAAA;IA/EtB;MAiFQ,UAAU,EAAA;MACZ;QAlFN;UAmFQ,UAAU,EAAA,EAEb;EArFL;IAyFM,UAAU;IACV,eAAe;IACf,mBAAmB,EAAA;IACnB;MA5FN;QA6FQ,sBAAsB,EAAA;QA7F9B;UA+FU,kBAAkB,EAAA,EACnB;;AAMT;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B,EAAA;EAJhC;IAMI,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAA;EARhB;IAWI,YAAY,EAAA;EAXhB;IAcI,gBAAgB;IAChB,WAAW,EAAA;;AAIf;EACE,SAAS,EAAA;;AAGX;EACE,yBAAyB,EAAA;EAD3B;IAGI,yBAAyB,EAAA","sourcesContent":[".agent-issuance-wrapper {\n  width: 80%;\n  .issue-card-wrapper {\n    padding: 5px 40px;\n  }\n\n  // .agent-issuance-table {\n  //   width: 650px;\n  // }\n\n  .no-action-row {\n    display: flex;\n    justify-content: center;\n    padding: 30px;\n    .no-action-message {\n      font-size: 25px;\n    }\n  }\n\n  .date-container {\n    // width: 100%;\n    text-align: left;\n    @media screen and (min-width: 768px) {\n      // width: calc( 50% - 24px );\n      margin-right: 24px;\n    }\n    span {\n      color: white;\n      width: 100px;\n      font-size: 19px;\n    }\n    .date-picker-field {\n      background-color: black;\n      border: none;\n      border-bottom: 1px solid white;\n      min-width: 240px;\n      width: 100%;\n      color: white;\n      min-width: 300px;\n    }\n  }\n\n  .switch-tabs {\n    display: flex;\n    flex-direction: row;\n    margin: 30px;\n    gap: 10px;\n    border-bottom: 1px solid white;\n    .tabs {\n      border: 1px solid white;\n      padding: 15px;\n      font-size: 18px;\n      background-color: black;\n      border-bottom: 0;\n      border-radius: 5px 5px 0 0;\n      margin-bottom: -2px;\n\n      &:hover {\n        background-color: grey;\n      }\n    }\n    .active {\n      color: var(--color-yellow);\n      text-decoration: var(--color-yellow) underline;\n      text-underline-offset: 5px;\n    }\n  }\n\n  .agent-issuance-fields {\n    display: flex;\n    flex-direction: row;\n    margin-top: 20px;\n    gap: 20px;\n    padding: 20px 50px;\n  }\n  .agent-issuance-filter {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    padding: 10px 50px;\n    .issuance-btn {\n        width: 80%;\n      @media screen and (min-width: 1200px) {\n        width: 40%;\n      }\n    }\n  }\n  .action-footer {\n    button {\n      width: 30%;\n      font-size: 16px;\n      margin-bottom: 14px;\n      @media (min-width: 720px) {\n        width: calc(50% - 7px);\n        &:first-child {\n          margin-right: 14px;\n        }\n      }\n    }\n  }\n}\n\n.issued-card-filter-buttons {\n  display: flex;\n  margin-top: 20px;\n  flex-direction: row;\n  justify-content: space-between;\n  .filter-buttons {\n    display: flex;\n    flex-direction: row;\n    width: 600px;\n  }\n  .export-buttons {\n    width: 300px;\n  }\n  button {\n    margin: 15px 7px;\n    width: 100%;\n  }\n}\n\n.add-spacing {\n  gap: 10px;\n}\n\n.MuiTableSortLabel-root {\n  color: #ffffff !important;\n  &:hover {\n    color: #ffffff !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
